import { BaseViewModel } from "./base.viewmodel";

export class PortfolioViewModel implements BaseViewModel {
    PageTitle: string = 'Portfolio';
}